import React, { useState, useEffect, useMemo } from "react";
import { Row, Card, CardBody, Button, Label, Col } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import { setBreadcrumbItems } from "../../store/actions";
import { connect } from "react-redux";
import Select from "react-select";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CourseWiseSeatsStatistics = (props) => {
    const navigate = useNavigate();
    document.title = "Technical Hub | Student Registration";

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const backendImgUrl = process.env.REACT_APP_BACKEND_IMAGE_URL;

    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [seatsAvailability, setSeatsAvailability] = useState([]);

    const currentYear = new Date().getFullYear();

    // Generate years dynamically from 2016 → currentYear+4
    const years = useMemo(() =>
        Array.from({ length: (currentYear + 4) - 2016 + 1 }, (_, i) => {
            const year = 2016 + i;
            return { value: year, label: year };
        })
        , [currentYear]
    );

    useEffect(() => {
        props.setBreadcrumbItems("Course Wise Seats Statistics", [
            { title: "Technical Hub", link: "#" },
            { title: "Statistics", link: "#" },
            { title: "Course Wise Seats Statistics", link: "#" },
        ]);
        fetchCourses();
    }, []);

    /** Fetch Courses */
    const fetchCourses = async () => {
        try {
            const res = await axios.get(`${backendUrl}get-courses`);
            if (res.status === 200) {
                setCourses(res.data || []);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to load courses");
        }
    };

    /** Submit Handler */
    const handleSubmit = async () => {
        if (!selectedCourse || !selectedYear) {
            toast.error("Please fill all required fields.");
            return;
        }

        try {
            const res = await axios.get(
                `${backendUrl}get-tech-wise-seats-availability-statistics/${selectedCourse.value}/${selectedYear.value}`
            );

            if (res.status === 200) {
                setSeatsAvailability(res.data.seatsAvailability || []);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to fetch data");
            setSeatsAvailability([]);
        }
    };

    const selectStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 })
    };

    return (
        <React.Fragment>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} transition={Bounce} theme="light" />

            <Row>
                <Col xl="12">
                    <Card>
                        <CardBody>
                            <h4 className="card-title mb-3">Seats Statistics</h4>

                            <AvForm onValidSubmit={handleSubmit}>
                                <Row>
                                    {/* Course Select */}
                                    <Col md="6" className="mb-4">
                                        <Label>Select Course <span className="text-danger">*</span></Label>
                                        <Select
                                            value={selectedCourse}
                                            onChange={(v) => {
                                                setSelectedCourse(v);
                                                setSeatsAvailability([]);  // Reset previous results
                                            }}
                                            options={courses.map(c => ({
                                                value: c._id,
                                                label: c.course_name,
                                            }))}
                                            placeholder="Choose Course"
                                            menuPortalTarget={document.body}
                                            styles={selectStyles}
                                        />
                                    </Col>

                                    {/* Year Select */}
                                    <Col md="6" className="mb-4">
                                        <Label>Select Passout Year <span className="text-danger">*</span></Label>
                                        <Select
                                            value={selectedYear}
                                            onChange={setSelectedYear}
                                            options={years}
                                            placeholder="Choose Year"
                                            menuPortalTarget={document.body}
                                            styles={selectStyles}
                                        />
                                    </Col>
                                </Row>

                                <Button color="primary" type="submit">Submit</Button>
                            </AvForm>

                            {/* Table */}
                            {seatsAvailability.length > 0 && (
                                <div className="mt-4">
                                    <h4 className="fw-bold mb-3">Seats Availability Statistics</h4>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped text-center">
                                            <thead className="table-dark">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Technology</th>
                                                    <th>Total Seats</th>
                                                    <th>Filled</th>
                                                    <th>Available</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {seatsAvailability.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td className="d-flex align-items-center justify-content-center gap-2">
                                                            <img
                                                                src={`${backendImgUrl}technology-icons/${item.technology_icon}`}
                                                                alt={item.technology_name}
                                                                width="25"
                                                                style={{ borderRadius: 4 }}
                                                            />
                                                            {item.technology_name}
                                                        </td>
                                                        <td>{item.total_seats}</td>
                                                        <td className="text-danger fw-bold">{item.filled_seats}</td>
                                                        <td className="text-success fw-bold">{item.available_seats}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default connect(null, { setBreadcrumbItems })(CourseWiseSeatsStatistics);
